import { Grid } from '@shopify/polaris';
import { RequireActionCard } from './RequireActionCard.tsx';
import { InformationCard } from './InformationCard.tsx';
import { useState } from 'react';

interface Props {
  checkedStep: string[];
  isActiveEmbed: boolean;
  themeId?: string;
  hasEnableMethods?: {
    isEnablePickup: boolean;
    isEnableDelivery: boolean;
    isEnableShipping: boolean;
  };
}

export const SetupInformation = ({ checkedStep, isActiveEmbed, themeId, hasEnableMethods }: Props) => {
  const [isOpen, setIsOpen] = useState({
    requireCard: true,
    inforCard: true,
  });

  if (!isOpen.inforCard && !isOpen.requireCard) {
    return null;
  }

  return (
    <Grid columns={{ xs: 6, lg: 12 }} gap={{ xs: '400' }}>
      {isOpen.requireCard && (
        <Grid.Cell columnSpan={{ lg: isOpen.inforCard ? 8 : 12, md: isOpen.inforCard ? 3 : 6, xs: 6 }}>
          <RequireActionCard
            checkedStep={checkedStep}
            isActiveEmbed={isActiveEmbed}
            themeId={themeId}
            isOpen={isOpen.requireCard}
            onClose={() => setIsOpen((prev) => ({ ...prev, requireCard: false }))}
            isEnableMethod={hasEnableMethods && Object.values(hasEnableMethods).some((value) => value === true)}
          />
        </Grid.Cell>
      )}
      {isOpen.inforCard && (
        <Grid.Cell columnSpan={{ lg: isOpen.requireCard ? 4 : 12, md: isOpen.requireCard ? 3 : 6, xs: 6 }}>
          <InformationCard isOpen={isOpen.inforCard} onClose={() => setIsOpen((prev) => ({ ...prev, inforCard: false }))} />
        </Grid.Cell>
      )}
    </Grid>
  );
};
